export default "__VITE_ASSET__vcuVquS9__ 400w, __VITE_ASSET__C8BwSYYP__ 800w, __VITE_ASSET__JW_aeAUj__ 1200w";